import { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Textarea } from "./ui/textarea";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { Store, Upload, Lock, Crown } from "lucide-react";

export function StoreDialog({ open, onClose, store, setStore, onOpenPricing }) {
  const { isPro } = useAuth();
  const [form, setForm] = useState(store);
  useEffect(() => { setForm(store); }, [store, open]);

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const handleLogo = (file) => {
    if (!file) return;
    if (!isPro) { toast.info("Upload logo hanya untuk akun Pro"); return; }
    if (file.size > 400 * 1024) return toast.error("Ukuran logo maksimal 400KB");
    const reader = new FileReader();
    reader.onload = () => set("logo", reader.result);
    reader.readAsDataURL(file);
  };

  const save = () => {
    setStore(form);
    toast.success("Profil toko disimpan");
    onClose?.();
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose?.()}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2" style={{ fontFamily: "'Outfit', sans-serif" }}>
            <Store size={20} className="text-sky-600" /> Profil Toko (Pengirim)
          </DialogTitle>
          <DialogDescription>Data pengirim & logo toko yang muncul di label resi.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div className="space-y-1">
            <Label className="text-xs text-slate-500">Nama Toko</Label>
            <Input data-testid="store-profile-name-input" value={form.storeName || ""}
              onChange={(e) => set("storeName", e.target.value)} placeholder="Toko Berkah Jaya" />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-1">
              <Label className="text-xs text-slate-500">Nama Pengirim</Label>
              <Input value={form.senderName || ""} onChange={(e) => set("senderName", e.target.value)} placeholder="Pak Andi" />
            </div>
            <div className="space-y-1">
              <Label className="text-xs text-slate-500">No HP Pengirim</Label>
              <Input data-testid="store-profile-phone-input" value={form.senderPhone || ""}
                onChange={(e) => set("senderPhone", e.target.value)} placeholder="0812xxxx" />
            </div>
          </div>
          <div className="space-y-1">
            <Label className="text-xs text-slate-500">Alamat Pengirim</Label>
            <Textarea data-testid="store-profile-address-input" value={form.senderAddress || ""}
              onChange={(e) => set("senderAddress", e.target.value)} placeholder="Jl. ... , Kota" />
          </div>

          <div className="space-y-1">
            <Label className="text-xs text-slate-500 flex items-center gap-1">
              Logo Toko {!isPro && <Lock size={12} className="text-orange-500" />}
            </Label>
            {isPro ? (
              <div className="flex items-center gap-3">
                {form.logo && <img src={form.logo} alt="logo" className="h-12 w-12 object-contain border rounded" />}
                <label className="cursor-pointer">
                  <input type="file" accept="image/*" className="hidden" data-testid="store-logo-upload-input"
                    onChange={(e) => handleLogo(e.target.files[0])} />
                  <span className="inline-flex items-center gap-1.5 text-sm border rounded-lg px-3 py-2 hover:bg-slate-50">
                    <Upload size={14} /> Pilih Logo
                  </span>
                </label>
                {form.logo && <Button variant="ghost" size="sm" className="text-red-500 text-xs" onClick={() => set("logo", "")}>Hapus</Button>}
              </div>
            ) : (
              <button onClick={() => { onClose?.(); onOpenPricing?.(); }}
                className="w-full flex items-center justify-center gap-2 text-sm border border-dashed border-orange-300 rounded-lg px-3 py-2.5 text-orange-600 hover:bg-orange-50">
                <Crown size={14} /> Upgrade Pro untuk upload logo
              </button>
            )}
          </div>
        </div>
        <Button data-testid="btn-save-store" onClick={save} className="mt-2 bg-sky-600 hover:bg-sky-700">Simpan Profil</Button>
      </DialogContent>
    </Dialog>
  );
}
